import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSolidPhoneCall } from "react-icons/bi";
import { Button } from "react-bootstrap";
// import { color } from "@mui/system";
import "../App.css";
import { useTranslation } from "react-i18next";
import HelmetSeo from "./HelmetSeo";

const DirectCall = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [callStatus, setCallStatus] = useState("");

  useEffect(() => {
    console.log("props", location);
    setCallStatus(location.state.callStatus);
  }, [callStatus, location]);

  console.log("callStatus", callStatus);

  const navigate = useNavigate();

  return (
    <div>
      <HelmetSeo
        title="Direct Call Consultation | Vasthuparam"
        content="Connect directly with a Vasthuparam expert for real-time guidance on home, land, or Vedic astrology via a direct call."
        name="description"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/directcall"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/directcall"
      />

      <div className="contnent">
        <div className="hlo">
          <h3>{callStatus}...</h3>{" "}
        </div>
        <div class="pluse">
          <BiSolidPhoneCall className="i" size={50} />
        </div>
        <div>
          <Button variant="outline-warning" onClick={() => navigate("/")}>
            {t("TXT.CLO.LO")}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default DirectCall;
